import React, { useContext, createContext } from 'react'
import firebase from "firebase/app"
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

import config from './config'

const firebaseContext = createContext()

firebase.initializeApp(config)

export function FirebaseProvider({ children }) {
  const firebase = useFirebaseProvider()
  return (
    <firebaseContext.Provider value={firebase}>
      {children}
    </firebaseContext.Provider>
  )
}

export function useFirebase() {
  return useContext(firebaseContext)
}

function useFirebaseProvider() {
  return {
    // auth
    loginWithEmail: async (email, password) => {
      await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      return firebase.auth().signInWithEmailAndPassword(email, password)
    },
    signupWithEmail: (email, password) => {
      return firebase.auth().createUserWithEmailAndPassword(email, password)
    },
    sendPasswordReset: (email) => {
      return firebase.auth().sendPasswordResetEmail(email)
    },
    signOut: () => {
      return firebase.auth().signOut()
    },
    checkUserAuth: user => {
      return firebase.auth().onAuthStateChanged(user)
    },
    getUser: () => {
      return firebase.auth().currentUser
    },
    auth: () => {
      return firebase.auth()
    },

    getServerTime: () => {
      return firebase.firestore.Timestamp.now()
    },
    toDate: date => {
      return firebase.firestore.Timestamp.fromDate(date)
    },

    // firestore
    getProfile: uid => {
      return firebase
        .firestore()
        .collection('users')
        .doc(uid)
        .get()
    },
    savePushToken: token => {
      const { uid } = firebase.auth().currentUser
      return firebase
        .firestore()
        .collection('users')
        .doc(`${uid}`)
        .update({ token_push: token })
    },
    getDocRef: (collection, id) => {
      return firebase.firestore().doc(`${collection}/${id}`)
    },
    getCollectionRef: collection => {
      return firebase
        .firestore()
        .collection(collection)
    },
    getStorageFile: (path, file) => {
      const date = new Date().toISOString().substring(0, 10)
      return firebase
        .storage()
        .ref(path).child(date).child(file.name)
    }
  }
}
